<template>
  <div class="zsrz_fr wow bounceInRight" data-wow-offset="300">

<!--    <upload :uploadType="`head`" :imgWidth="`85px`" :imgHeight="`104px`" :imgUrl="imgUrl"-->
<!--            @upload="getImgUrl"></upload>-->


<!--    <p class="zsrz_frb">开通服务<br>助力您的业务腾飞</p>-->
<!--    <form action="" class="zsrz_frform layui-form" method="get">-->
<!--      <input name="" class="zsrz_frinput" placeholder="公司名称" type="text" v-model="name">-->
<!--      <input name="" class="zsrz_frinput" placeholder="联系人" type="text" v-model="contact">-->
<!--      <input name="" class="zsrz_frinput" placeholder="联系电话" type="text" v-model="contactPhone">-->
<!--      <input name="" class="zsrz_frinput" placeholder="联系邮箱" type="text" v-model="email">-->
<!--      <input name="" class="zsrz_frinput" placeholder="公司地址" type="text" v-model="address">-->
<!--      <input name="" class="zsrz_frinput" placeholder="推广人" type="text" v-model="promoter">-->
<!--      <input name="" class="zsrz_frzc" type="button" value="立即注册" @click="regist()" >-->
<!--      <p class="zsrz_frz">我们会在1个工作日内审核完毕</p>-->
<!--    </form>-->

    <p class="zsrz_frb">开通服务<br>助力您的业务腾飞</p>
    <form action="" class="zsrz_frform" method="get" >
      <div class="content_a">
        <div class="form_l">
          <div class="item"><input v-model="company.name" name="" :disabled="edit" :class="['zsrz_frinput', edit ? 'disabled' : '']" placeholder="公司名称" type="text"><em>*</em></div>
          <div class="item"><input v-model="company.contact" name="" class="zsrz_frinput" placeholder="联系人" type="text"><em>*</em></div>
          <div class="item"><input v-model="company.contactPhone" name="" class="zsrz_frinput" placeholder="联系电话" type="text"><em>*</em></div>
          <div class="item"><input v-model="company.email" name="" class="zsrz_frinput" placeholder="联系邮箱" type="text"><em>*</em></div>
          <div class="item"><input v-model="company.address" name="" class="zsrz_frinput" placeholder="公司地址" type="text"><em>*</em></div>
          <div class="item"><input v-model="company.promoter" name="" class="zsrz_frinput" placeholder="推广人" type="text"></div>
        </div>
        <div class="form_r">
          <div class="item upload">
            <div class="tit">企业LOGO</div>
<!--            <input type="button" value="选择图片" class="btn-file" />-->
            <upload id="logo" :photo="photo" ref="upload"></upload>
<!--            <div class="preview">-->
<!--              <span>预览</span>-->
<!--              <div class="hover"><img src="images/brand_280_otw.jpg" /></div>-->
<!--            </div>-->
          </div>
<!--          <input type="hidden" v-model="logo" name="logo"/>-->
          <div class="item"><input v-model="company.officialWeb" name="" class="zsrz_frinput" placeholder="企业官网网址" type="text"></div>
          <div class="item"><input v-model="company.brief" name="" class="zsrz_frinput" placeholder="一句话简介" type="text"></div>
          <div class="item" style="padding-left:90px;height: 48px;">
            <div class="tit">入驻角色</div>
            <div class="con">
              <div class="ele"><input type="checkbox" v-model="types" value="1"/>资源方</div>
              <div class="ele"><input type="checkbox" v-model="types" value="2"/>采购方</div>
            </div>
            <em>*</em>
          </div>
          <div class="item">
            <div class="tip">(可同时勾选资源方和采购方)</div>
          </div>
        </div>
      </div>
      <div class="content_b">
        <textarea v-model="company.desc" placeholder="企业介绍(公司基本情况，主营业务，核心优势)" maxlength="800"></textarea>
      </div>
      <div class="op"><input name="" class="zsrz_frzc" type="button" value="提交" lay-submit lay-filter="login" @click="regist()"></div>
      <p class="zsrz_frz">我们会在1个工作日内审核完毕</p>
    </form>
  </div>
</template>

<script>
    // export default {
    //       name: 'HelloWorld',
    //       props: {
    //         msg: String
    //       }
    // }
    // import api from '../api/api'
    import layer from "layui-layer";
    import upload from './upload';

    export default {
      name: 'zsrz',
      components: {
        upload
      },
      data: function(){
        return {
          company: {
            "id": null,
            "name":null,
            "contact":null,
            "contactPhone":null,
            "email":null,
            "address":null,
            "promoter":null,
            "logo":null,
            "officialWeb":null,
            "brief":null,
            "desc":null,
            "type":null
          },
          "types":[],
          photo: [],
          edit: false,
          selectFile: false
        }
      },
      watch: {
        types: function (val) {
          console.log("watch types: " + val);
          let type = 0;
          if(val && val.length > 0){
            for(let i in val){
              let v = val[i];
              v = parseInt(v);
              if(type){
                type += v;
              } else {
                type = v;
              }
            }
          }
          this.company.type = type;
        }
      },
      created: function(){
        console.log('zsrz created');
        let companyId = localStorage.getItem("curUserCompanyId");
        if(companyId){
          this.edit = true;
          this.company.id = companyId;
          this.detail();
        }
      },
      methods: {
        regist: function () {
          console.log("regist start")
          // let lay1 = layer.open({fixed: false,type:3});
          if(!this.company.type){
            layer.msg('必填项不可为空', {fixed: false});
            return false;
          }
          this.company.logo = this.$refs.upload.logo;
          console.log("this.$refs.upload.logo: " + this.$refs.upload.logo);
          if(this.selectFile && !this.company.logo){
            layer.msg('图片上传中，请稍后提交。', {fixed: false});
            return;
          }
          this.$http.post('/company/regist', this.company, function(data){
            console.log("result is suc: " + data)
            // layer.close(lay1);
            if(data && data == 200){
              layer.msg("您的信息已收到、我们的工作人员会在24小时内和您联系！", {fixed: false, time: 10000});
            } else {
              layer.msg(data, {fixed: false});
            }
          }, function (data) {
            console.log("result is fail: " + data)
            // layer.close(lay1);
            if(data){
              layer.msg(data, {fixed: false});
            }
          })

        },
        detail: function () {
          let _this = this;
          if(!this.edit){
            console.log("company id is null: " + this.company.id);
            return;
          }
          this.$http.post('/company/' + this.company.id, null, function (re) {
            if(re.code == '000000'){
              if(re.data){
                _this.company = re.data;
                let p = {};
                p.src = _this.company.logo;
                _this.photo[0] = p;

                if(re.data.type == 3){
                  _this.types[0] = 1;
                  _this.types[1] = 2;
                } else {
                  _this.types[0] = re.data.type;
                }
              }
            } else {
              layer.msg(re.message, {fixed: false});
            }
          }, function (re) {
            console.log('company detail re:' + re);
          })
        }
      }
    }
    // var zsrz = new Vue({
    //   el: '.zsrz_frform',
    //   data: {
    //     "Name":null,
    //     "Industry":null,
    //     "Contact":null,
    //     "ContactPhone":null,
    //     "Address":null
    //   },
    //   methods: {
    //     regist: function () {
    //       this.$http.post('/api/enterprise/register', zsrz.$data, function(data){
    //         console.log(data);
    //       }, function (data) {
    //         console.log(data);
    //       })
    //     }
    //   }
    // });
</script>

<style scoped>
  .disabled{
    background-color: #d8d8d8;
  }
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!--<style scoped>-->
<!--h3 {-->
<!--  margin: 40px 0 0;-->
<!--}-->
<!--ul {-->
<!--  list-style-type: none;-->
<!--  padding: 0;-->
<!--}-->
<!--li {-->
<!--  display: inline-block;-->
<!--  margin: 0 10px;-->
<!--}-->
<!--a {-->
<!--  color: #42b983;-->
<!--}-->
<!--</style>-->
